module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// ./~/browserify-sign/~/readable-stream/lib/internal/streams/stream-browser.js